/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 24/11/2013
 * Time: 15:53
 * To change this template use File | Settings | File Templates.
 */



angular.module('FlexyBeautyApp.services').
    factory('Site_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        return  $resource(baseUrl+'rest/sites/:id',{}, {
            query: { method: 'GET', isArray: true },
            get:   { method: 'GET' },
            getFromCode: { method: 'GET', url: baseUrl + 'rest/sites/from-code'},
            saveFromCode: { method: 'POST', url: baseUrl + 'rest/sites/:companyCode'},
            addWorkingPeriod: {method: 'POST',url: baseUrl + 'rest/sites/addWorkingPeriod'},
            removeWorkingPeriod: {method: 'DELETE',url: baseUrl + 'rest/sites/removeWorkingPeriod/:siteId/:id'}
        });
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('Site',["Site_Resource","WorkingPeriod","Period","Countries","HumanResourceData",
        function (Site_Resource,WorkingPeriod,Period,Countries,HumanResourceData)
        {
        //Site inherit of $resource

        var Site = function (resource, isApplicationLoading)
        {
            this.id = null;
            this.preposition = null;
            this.name = null;
            this.phone = null;
            this.emailContact = null;
            this.emailBooking = null;
            this.fax = null;
            this.address = null;
            this.postalCode = null;
            this.city = null;
            this.country = null;
            this.timeZone = null;
            this.departement = null;
            this.siret = null;
            this.rcs = null;
            this.shareCapital = null;
            this.vatNumber = null;
            this.nafCode = null;
            this.webSiteDir = null;
            this.workingPeriods = [];
            this.version = null;
            this.ownerId = null;
            this.legalName = null;
            this.legalAddress = null;
            this.legalCity = null;
            this.legalZip = null;
            this.legalCountry = null;
            this.greffeCity = null;
            this.juridicForm = null;
            if (resource !== undefined && resource != null)
            {
                this.loadObject(resource, isApplicationLoading);
            }
        };

        Site.prototype.isFrenchLocation = function()
        {
            if(this.country === Countries.FRANCE.countryCode){
                return true;
            }
            else {
                return false;
            }
        };

        Site.prototype.loadObject = function(object, isApplicationLoading)
        {
            if (!this.id)
                this.id = object.id;
            this.name = object.name;
            this.preposition = object.preposition;
            this.phone = object.phone;
            this.emailContact = object.emailContact;
            this.emailBooking = object.emailBooking;
            this.fax = object.fax;
            this.address = object.address;
            this.postalCode = object.postalCode;
            this.city = object.city;
            this.country = object.country;
            this.timeZone = object.timeZone;
            this.departement = object.departement;
            this.siret = object.siret;
            this.rcs = object.rcs;
            this.shareCapital = object.shareCapital;
            this.nafCode = object.nafCode;
            this.vatNumber = object.vatNumber;
            this.webSiteDir = object.webSiteDir;
            this.ownerId = object.ownerId;
            this.legalName = object.legalName;
            this.legalAddress = object.legalAddress;
            this.legalCity = object.legalCity;
            this.legalZip = object.legalZip;
            this.legalCountry = object.legalCountry;
            this.greffeCity = object.greffeCity;
            this.juridicForm = object.juridicForm;
            if (object.workingPeriods)
            {
                this.workingPeriods = [];
                for (var i =0;i< object.workingPeriods.length;i++)
                {
                    this.workingPeriods.push(new WorkingPeriod(object.workingPeriods[i],this,isApplicationLoading));
                }
            }
            if (object.version)
                this.version = object.version;
        };
        Site.prototype.getObjectResource = function()
        {
            var rsSite = new Site_Resource();
            rsSite.id = this.id
            rsSite.name = this.name;
            rsSite.preposition = this.preposition;
            rsSite.phone = this.phone;
            rsSite.emailContact = this.emailContact;
            rsSite.emailBooking = this.emailBooking;
            rsSite.fax = this.fax;
            rsSite.address = this.address;
            rsSite.postalCode = this.postalCode;
            rsSite.city = this.city;
            rsSite.country = this.country;
            rsSite.timeZone = this.timeZone;
            rsSite.departement = this.departement;
            rsSite.siret = this.siret;
            rsSite.nafCode = this.nafCode;
            rsSite.vatNumber = this.vatNumber;
            rsSite.webSiteDir = this.webSiteDir;
            rsSite.rcs = this.rcs;
            rsSite.shareCapital = this.shareCapital;
            rsSite.ownerId = this.ownerId;
            rsSite.legalName = this.legalName;
            rsSite.legalAddress = this.legalAddress;
            rsSite.legalCity = this.legalCity;
            rsSite.legalZip = this.legalZip;
            rsSite.legalCountry = this.legalCountry;
            rsSite.greffeCity = this.greffeCity;
            rsSite.juridicForm = this.juridicForm;

            rsSite.workingPeriods = [];

            if (this.workingPeriods)
                for (var i =0;i< this.workingPeriods.length;i++)
                {
                    rsSite.workingPeriods.push(this.workingPeriods[i].getObjectResource());
                }

            return rsSite;
        };
        Site.prototype.addWorkingPeriod = function(workingPeriod)
        {
            this.workingPeriods.push(workingPeriod);
            return this.workingPeriods.length-1;//return position

        };

        Site.prototype.removeWorkingPeriod = function(workingPeriod)
        {
            var index =  this.workingPeriods.indexOf(workingPeriod);
            if (index!=-1)
                this.workingPeriods.splice(index,1);
        };
        Site.prototype.isWorkingPeriod= function(dayOfWIndex,hrId,period)
        {
            var isWorkingPeriod = false;
            for (var i =0;i< this.workingPeriods.length&&!isWorkingPeriod;i++)
                isWorkingPeriod= this.workingPeriods[i].isWorkingPeriod(dayOfWIndex,hrId,period);
            return isWorkingPeriod;
        };
        Site.prototype.getMaxOpeningPeriod= function()
        {
            var maxPeriod = new Period();
            maxPeriod.start.hour = 24;
            var wp;
            for (var i =0;i< this.workingPeriods.length;i++)
            {
                wp =  this.workingPeriods[i];
                if (wp.period)
                {
                    if ((wp.period.start.getTime())<(maxPeriod.start.getTime()))
                        maxPeriod.setStart(wp.period.start)
                    if ((wp.period.end.getTime())>(maxPeriod.end.getTime()))
                        maxPeriod.setEnd(wp.period.end)
                }
            }
            return maxPeriod;
        };
        Site.prototype.getDefaultPeriodsOfWork= function(dayOfWIndex,hrId)
        {
            // return periods of work according : dayOfWIndex + Hrid
            // if period null get site opening
            var periods = [];
            var period = null;
            for (var i =0;i< this.workingPeriods.length;i++)
            {
                period = this.workingPeriods[i].getDefaultPeriodOfWork(dayOfWIndex,hrId);
                if (period)
                {
                    period.openDay = this.workingPeriods[i].workingPeriodDays[dayOfWIndex].openDay;
                    period.wpIndex = i;
                    periods.push(period);
                }
            }
            if (periods.length==0 && this.workingPeriods.length!=0)//no open day : use time of first open
                periods.push(this.workingPeriods[0].period);
            return periods;
        };
        Site.prototype.getPeriodsOfWorkPr = function(dayOfWIndex,prId,prUnitId)
        {
            // return periods of work according : dayOfWIndex + Hrid
            var periods = [];
            var period = null;
            for (var i =0;i< this.workingPeriods.length;i++)
            {
                period = this.workingPeriods[i].getPeriodOfWorkForPr(dayOfWIndex,prId,prUnitId);
                if (period)
                {
                    period.wpIndex = i;
                    periods.push(period);
                }
            }
            return periods;
        };
        Site.prototype.getPeriodsOfWork = function(dayOfWIndex,hrId)
        {
            // return periods of work according : dayOfWIndex + Hrid
            var periods = [];
            var period = null;
            for (var i =0;i< this.workingPeriods.length;i++)
            {
                period = this.workingPeriods[i].getPeriodOfWorkForHr(dayOfWIndex,hrId);
                if (period)
                {
                    period.wpIndex = i;
                    periods.push(period);
                }
            }
            return periods;
        };
        Site.prototype.prIsWorking = function(dayOfWIndex,prId,prUnitId)
        {
            // allow to know if pr is working according opened period of work dayOfWIndex + prid
            var prIsWorking = false;
            var periodsOfWork = this.getPeriodsOfWorkPr(dayOfWIndex,prId,prUnitId);
            prIsWorking =  periodsOfWork && periodsOfWork.length>0;
            return prIsWorking;
        };
        Site.prototype.hrIsWorking = function(dayOfWIndex,hrId)
        {
            // allow to know if hr is working according opened period of work dayOfWIndex + Hrid
            var hrIsWorking = false;
            var periodsOfWork = this.getPeriodsOfWork(dayOfWIndex,hrId);
            hrIsWorking =  periodsOfWork && periodsOfWork.length>0;
            return hrIsWorking;
        };
        Site.prototype.getHrWorkingTime = function(dayOfWIndex,hrId)
        {
            // allow to get hr workingTime by dayOfWIndex and hrid
            //check default site data

            var hrWorkingTime = 0;
            var periodsOfWork = this.getPeriodsOfWork(dayOfWIndex,hrId);
            if (periodsOfWork)
                for (var i =0;i< periodsOfWork.length;i++)
                    hrWorkingTime += periodsOfWork[i].duration;
            return hrWorkingTime;
        };
        Site.prototype.getPrWorkingTime = function(dayOfWIndex,prId,prUnitId)
        {
            // allow to get hr workingTime by dayOfWIndex and hrid
            //check default site data

            var prWorkingTime = 0;
            var periodsOfWork = this.getPeriodsOfWorkPr(dayOfWIndex,prId,prUnitId);
            if (periodsOfWork)
                for (var i =0;i< periodsOfWork.length;i++)
                    prWorkingTime += periodsOfWork[i].duration;
            return prWorkingTime;
        };
        Site.prototype.getOpenWorkingPeriodIndex= function(dayOfWIndex,hrId,period)
        {
            // return workingPeriod index according : dayOfWIndex + Hr id who is open for an period
            for (var i =0;i< this.workingPeriods.length;i++)
                if (this.workingPeriods[i].isOpenWorkingPeriodForHr(dayOfWIndex,hrId,period))
                    return i;
            return -1;
        };
        Site.prototype.getWorkingPeriodById = function(id)
        {
            for (var i =0;i< this.workingPeriods.length;i++)
                if (this.workingPeriods[i].id==id)
                    return this.workingPeriods[i];
            return null;
        };
        Site.prototype.getWpDays = function(dayOfWIndex)
        {
            // allow to get wpdays for dayOfW Index hrId
            //check default site data
            var wpDays = [];
            for (var i =0;i< this.workingPeriods.length;i++)
                wpDays.push(this.workingPeriods[i].getWpDay(dayOfWIndex));
            return wpDays;
        };

        // statistic module
        Site.prototype.isOpenDay = function(dayOfWeekId)
        {
            for(var i=0; i<this.workingPeriods.length; i++)
            {
                if(this.workingPeriods[i].workingPeriodDays[dayOfWeekId].openDay)
                    return true;
            }
            return false;
        };

        Site.prototype.isWorkingPeriodDayHrOnlineBooking = function(dayOfWIndex, humanResourceId) {
            let onlineBooking = false;
            for(let i = 0; i < this.workingPeriods.length; i++) {
                let workingPeriodDay = this.workingPeriods[i].workingPeriodDays[dayOfWIndex];
                if (workingPeriodDay && workingPeriodDay.openDay) {
                    let workingPeriodDayHr = workingPeriodDay.getWorkingPeriodDayHr(humanResourceId);
                    if (!workingPeriodDayHr || workingPeriodDayHr.onLineBooking) {
                        onlineBooking = true;
                        break;
                    }
                }
            }
            return onlineBooking;
        };

        Site.prototype.isWorkingPeriodDayPrOnlineBooking = function(dayOfWIndex, physicalResourceId, prUnitId) {
            let onlineBooking = false;
            for(let i = 0; i < this.workingPeriods.length; i++) {
                let workingPeriodDay = this.workingPeriods[i].workingPeriodDays[dayOfWIndex];
                if (workingPeriodDay && workingPeriodDay.openDay) {
                    let workingPeriodDayPr = workingPeriodDay.getWorkingPeriodDayPr(physicalResourceId, prUnitId);
                    if (!workingPeriodDayPr || workingPeriodDayPr.onLineBooking) {
                        onlineBooking = true;
                        break;
                    }
                }
            }
            return onlineBooking;
        };

        Site.prototype.areMigrationInformationComplete = function(hasAccessToWebsite, posAppAttribute) {
            const owner = this.ownerId != null ? HumanResourceData.getById(this.ownerId) : null;
            let isValid = this.name != null
              && this.workingPeriods != null
              && this.workingPeriods.length > 0
              && this.ownerId != null
              && this.legalName != null
              && this.address != null
              && this.city != null
              && this.postalCode != null
              && this.country != null
              && this.phone != null
              && this.siret != null
              && this.vatNumber != null
              && this.legalAddress != null
              && this.legalCity != null
              && this.legalZip != null
              && this.legalCountry != null
              && owner != null
              && owner.email != null
              && owner.phone != null

            if (isValid && hasAccessToWebsite) {
                isValid = this.emailContact != null && this.webSiteDir != null;
            }

            if(isValid && posAppAttribute != null){
                let isAdvanceAttr = posAppAttribute.getAppAttribute("advanceMng");
                if(isAdvanceAttr && isAdvanceAttr.value === "true") {
                    isValid = this.rcs != null
                }
            }
            return isValid;
        };

        return Site;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('SiteSrv',["$log","Site_Resource","Site","SiteData","UserActionData","ServerSrv",
        function ($log,Site_Resource,Site,SiteData,UserActionData,ServerSrv)
        {
        var  siteSrv = {};

        siteSrv.query = function(successFunction,errorFunction, isApplicationLoading)
        {
            Site_Resource.query(
                {}, //params
                function (data) {   //success
                    //Data is an Array
                    SiteData.clear();

                    for (var i=0;i< data.length;i++)
                        SiteData.sites.push(new Site(data[i], isApplicationLoading));
                    if (SiteData.sites.length>0)
                    {
                        SiteData.defaultSite = SiteData.sites[0];
                    }

                    if (successFunction!== undefined)
                        successFunction(SiteData.defaultSite);
                },
                function (data) {
                    $log.error(data);
                    if (errorFunction!== undefined)
                        errorFunction(data);
                });
        };
        siteSrv.save = function(site,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(siteSrv.saveSync, site, successFunction, errorFunction);
        };
        siteSrv.saveSync =  function(site,successFunction,errorFunction)
        {
            var siteRes = site.getObjectResource();
            siteRes.$save({}, //no params
                function (data) {
                    try{
                        if (!site.id)
                            site.id = data.id;
                        if (!site.version || (data.version && data.version > site.version))
                            site.version = data.version;
                        /** @namespace data.workingPeriodsId */
                        var wpData;var wp;
                        if (data.workingPeriods && data.workingPeriods.length==site.workingPeriods.length)
                        //Assume that returned list has the same order
                            for (var i=0;i< data.workingPeriods.length;i++)
                            {
                                wpData =  data.workingPeriods[i];
                                wp = site.workingPeriods[i];
                                wp.setId(wpData.id);
                                if (wpData.workingPeriodDaysId && wpData.workingPeriodDaysId.length==wp.workingPeriodDays.length)
                                    for (var j=0;j<wpData.workingPeriodDaysId.length;j++)
                                        wp.workingPeriodDays[j].id = wpData.workingPeriodDaysId[j];
                            }

                        //TODO UserActionData.add(data.userAction);

                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );
        };
        siteSrv.removeWorkingPeriod = function (site,workingPeriod,successFunction,errorFunction)
        {
            site.referenceWeek.removeWorkingPeriod(workingPeriod);
            ServerSrv.startSavingProcess(siteSrv.removeWorkingPeriodSync, site, workingPeriod, successFunction, errorFunction);
        };
        siteSrv.removeWorkingPeriodSync = function (site,workingPeriod,successFunction,errorFunction)
        {
            //$timeout (function () {

            var siteRes = new Site_Resource();
            siteRes.$removeWorkingPeriod({siteId:site.id,id:workingPeriod.id},
                function (data) {
                    //Save on server success :
                    // -> set id for new entity

                    // -> add an user action (send message)
                    try{
                        if (successFunction !=undefined)
                        successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };
        siteSrv.getSiteFromCode = function (companyCode) {
            return Site_Resource.getFromCode({'company-code':companyCode}).$promise;
        }
        siteSrv.saveFromCode = function (companyCode, site) {
            let siteResource = site.getObjectResource()
            return siteResource.$saveFromCode({companyCode:companyCode}).$promise;
        }
        siteSrv.addWorkingPeriod = function(site,workingPeriod,successFunction,errorFunction)
        {
            site.referenceWeek.addWorkingPeriod(workingPeriod);
            ServerSrv.startSavingProcess(siteSrv.addWorkingPeriodSync, site, workingPeriod, successFunction, errorFunction);
        };
        siteSrv.addWorkingPeriodSync = function(site,workingPeriod,successFunction,errorFunction)
        {
            var siteRes = new Site_Resource();
            siteRes.id = site.id;
            siteRes.workingPeriod = workingPeriod.getObjectResource();
            siteRes.$addWorkingPeriod({}, //no params
                function (data) {
                    try{
                        workingPeriod.id = data.id;
                        // -> add an user action (send message)

                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );
        };
        siteSrv.updateLocally =  function(objectToRestore)
        {
            var site =  SiteData.getById(objectToRestore.id)
            if (site!=null)
            {
                site.loadObject(objectToRestore);
                return site;
            }
            return null;
        };

        return siteSrv;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('SiteData',["$log", function ($log)
    {
        var  siteData = {
            sites : [],
            defaultSite : null
        };

        siteData.clear =  function()
        {
            this.sites = [];
        };
        siteData.getById =  function(siteId)
        {
            for (var i=0;i<this.sites.length;i++)
                if (this.sites[i].id==siteId)
                    return this.sites[i];
            return null;
        };

        return   siteData;
    }
    ]);



// WEBPACK FOOTER //
// ./js/services/models/Site.js